import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {MatPaginatorIntl} from "@angular/material/paginator";
import {MatPaginatorIntlService} from "./services";
import {
  AdjuntosTableComponent,
  ChacraDetailComponent,
  ChacraTableComponent,
  ContactoDetailComponent,
  EmpresaDetailComponent,
  EmpresaTableComponent,
  IngenieroAgronomoDetailComponent, MensajeDetailComponent, MensajeTableComponent,
  PadronListComponent,
  PersonaDetailComponent,
  RegionalDetailComponent,
  SueloDetailComponent,
} from "./components";
import {SharedModule} from "../shared/shared.module";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


const customComponents = [
  AdjuntosTableComponent,
  ChacraTableComponent,
  ChacraDetailComponent,
  PadronListComponent,
  SueloDetailComponent,

  PersonaDetailComponent,
  IngenieroAgronomoDetailComponent,
  ContactoDetailComponent,

  EmpresaTableComponent,
  EmpresaDetailComponent,

  RegionalDetailComponent,
  MensajeDetailComponent,
  MensajeTableComponent,
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  declarations: [...customComponents],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SharedModule,
    ...customComponents
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginatorIntlService
    }
  ]
})
export class ChacraCoreModule {
}
